const Feedback = () => {
  return (
    <>
      <p> Feedback</p>
    </>
  );
};

export default Feedback;
